angular.module('gym.sequences').controller('SequencesOptInCtrl', ["$scope", "$rootScope", "$state", "$window", "Sequences", "FreeTrialRemindMessageText", "GTMService", function($scope, $rootScope, $state, $window, Sequences, FreeTrialRemindMessageText, GTMService) {
  var billingPageUrl;
  $scope.isFeatureEnabled = !!_.find($rootScope.gym.features_enabled, function(feature) {
    return feature === 'sequences';
  });
  GTMService.trackPage('Sequences - Toggle');
  $scope.optIn = function() {
    GTMService.trackPage('Sequences - Toggle', 'Start using sequences');
    return Sequences.doPOST({}, 'opt_in').then(function() {
      var url;
      url = $state.href('gym.sequences.list');
      return $window.open(url, '_self');
    });
  };
  billingPageUrl = $state.href('gym.subscription.tab', {
    tab: 'subscriptions'
  });
  $scope.getRemindMessageText = FreeTrialRemindMessageText.get('Established', billingPageUrl);
  return $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
}]);
